<template>
  <div class="body_main">
    <div class="body_bd">
        <div class="main_bd">
            <div class="main_title">{{sysName}}，欢迎访问知夏中医门诊收费系统管理平台</div>
            <div class="bd_con">
                <div class="bd_con_li" @click="changeData('order')">
                    <el-icon><Memo /></el-icon>
                    <span class="li_sp">门诊订单</span>
                </div>
                <div class="bd_con_li" @click="changeData('treatorder')">
                    <el-icon><Coin /></el-icon>
                    <span class="li_sp">诊疗订单</span>
                </div>
                <div class="bd_con_li cursor_disabled">
                    <el-icon><monitor /></el-icon>
                    <span class="li_sp">商城工作台</span>
                </div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import home from "@/assets/scripts/home/index";
export default home;
</script>

<style scoped>
    .main_bd {
        width: 100%;
        height: calc(100% - 18vh);
        display: flex;
        flex-direction: column;
        justify-items: center;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .main_title {
        width: 100%;
        height: 8vh;
        font-size: 1.6rem;
        color: #333333;
        display: flex;
        justify-items: center;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .bd_con {
        width: 100%;
        height: 30vh;
        display: flex;
        justify-items: center;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .bd_con_li {
        width: 7rem;
        height: 7rem;
        padding: 1rem;
        margin: 0 1rem;
        display: flex;
        flex-direction: column;
        justify-items: center;
        justify-content: center;
        align-content: center;
        align-items: center;
        cursor: pointer;
        background: #f6f2f2;
        border-radius: 1rem;
    }

    .bd_con_li:hover {
        background: #e0dcdc;
        font-weight: bold;
    }

    .bd_con_li i {
        font-size: 3rem;
        color: #409EFF;
    }

    .li_sp {
        font-size: .875rem;
        line-height: 3rem;
    }

    .main_info {
        width: 100%;
        height: 10vh;
        font-size: .875rem;
        color: #333333;
        display: flex;
        justify-items: center;
        justify-content: center;
        align-content: center;
        align-items: center;
    }

    .main_info a {
        color: #409EFF;
        margin: 0 .2rem;
        cursor: pointer;
    }

    .main_info a:hover {
        font-weight: bold;
        color: #409EFF;
    }
</style>
